import { formatHTML } from "./exhibition-card";
(function () {
  let global_offset = 8;
  const $list = $(".js-n-old-exhibitions-list");
  $(".js-n-exhibitions-old-more").click(function (e) {
    const url = $(this).data("url");
    e.preventDefault();
    $(".js-old-exhibitions-section").addClass("n__events__wrapper--loading ");
    $.ajax({
      type: "get",
      dataType: "json",
      contentType: "application/json",
      url,
      data: {
        action: "n_more_old_exhibitions",
        offset: global_offset,
        lang: $("html").attr("lang"),
      },
      success: (res) => {
        if (!res.success) return;
        const { posts, has_more } = res.data;
        console.log(posts);
        global_offset += posts.length;
        if (has_more) {
          $(".n__exhibitions__show__more").show();
        } else {
          $(".n__exhibitions__show__more").hide();
        }
        if (posts.length) {
          $list.append(formatHTML(posts));
        }
        $(".js-old-exhibitions-section").removeClass(
          "n__events__wrapper--loading "
        );
      },
      error: (err) => {
        console.log(err);
      },
    });
  });
})();
